import { createApp } from 'vue';
require('./bootstrap');

window.Vue = require('vue').default;
window.tranlate=require('./VueTranslation/Translation').default.translate;
// import VueResource from 'vue-resource';
// Vue.use(VueResource);
// import VueRouter from 'vue-router';
// Vue.use(VueRouter);
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAdjust, faStar, faStarHalfAlt, faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons'
import { faStar as faStarReg } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Tooltip, Toast, Popover } from 'bootstrap';
import { i18nVue } from 'laravel-vue-i18n'
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

const app = createApp().use(i18nVue, {
				resolve: lang => import(`../lang/${lang}.json`),
			});

library.add(faAngleDoubleUp)
library.add(faStarReg)
library.add(faStar)
library.add(faStarHalfAlt)
library.add(faAdjust)

app.component('font-awesome-icon', FontAwesomeIcon)
app.component("VueDatePicker", VueDatePicker);
app.component("infinite-loading", InfiniteLoading);
app.component('home-latest-products', require('./components/HomeLatestProducts.vue').default);
app.component('recent-activities', require('./components/LatestActivities.vue').default);
app.component('product-type-page', require('./components/ProductTypePage.vue').default);
app.component('product-show-page', require('./components/ProductShowPage.vue').default);
app.component('review-ratings', require('./components/ReviewRatings.vue').default);
app.component('search-page', require('./components/SearchPage.vue').default);
app.component('mah-activities', require('./components/MahActivities.vue').default);
app.component('inwood-activities', require('./components/InwoodActivities.vue').default);

app.mount('#app')

import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);
new Swiper('#clientProducts .swiper-products-container', {
	slidesPerView: "auto",
	spaceBetween: 10,
	//slidesPerGroupSkip: 1,
	breakpoints: {
		320: {
			slidesPerGroup: 2,
		},
		480: {
			slidesPerGroup: 2,
		},
		640: {
			slidesPerGroup: 3,
		},
		768: {
			slidesPerGroup: 4,
		},
	},
	// breakpointsInverse: true,
	navigation: {
		nextEl: '#clientProducts .swiper-product-next',
		prevEl: '#clientProducts .swiper-product-prev',
	}
});
new Swiper('#TopActivities .swiper-products-container', {
	slidesPerView: "auto",
	spaceBetween: 10,
	//slidesPerGroupSkip: 1,
	breakpoints: {
		320: {
			slidesPerGroup: 2,
		},
		480: {
			slidesPerGroup: 3,
		},
		640: {
			slidesPerGroup: 3,
		},
		768: {
			slidesPerGroup: 4,
		},
	},
	// breakpointsInverse: true,
	navigation: {
		nextEl: '#TopActivities .swiper-product-next',
		prevEl: '#TopActivities .swiper-product-prev',
	}
});
new Swiper('.swiper-producttypes-container', {
	slidesPerView: "auto",
	spaceBetween: 10,
	//slidesPerGroupSkip: 1,
	breakpoints: {
		320: {
			slidesPerGroup: 2,
		},
		480: {
			slidesPerGroup: 2,
		},
		640: {
			slidesPerGroup: 3,
		},
		768: {
			slidesPerGroup: 4,
		},
	},
	// breakpointsInverse: true,
	navigation: {
		nextEl: '.swiper-producttypes-next',
		prevEl: '.swiper-producttypes-prev',
	}
});

// Live search
function search() {
	var websiteId = $(".search-input-group").data('website');
	var lang = $(".search-input-group").data('lang');
	var keyword = $(".search-input-group input[name=keyword]").val();
	if(keyword !== ''){
		$.ajax({
			url: process.env.MIX_API_URL+'/'+websiteId+'/search_quick',//'/api/search?q='+keyword,
			type: 'GET',
			data: { query: keyword },
			dataType: 'json',
			beforeSend: function (){
				$('.button-clear').fadeIn();
			},
			success:function(response) {
				$('ul#search-results').empty();
				$('.search-no-results').fadeOut();
				if(response.length >= 1) {
					$.each(response, function( key, item ) {
						$('ul#search-results').append('<li class="list-group-item ps-0"><a class="link-primary" href="/t/'+item.type+'/'+item.id+'/'+item.slug+'">'+item.title[lang]+'</a></li>');
					});
				} else {
					$('.search-no-results').fadeIn();
					$('ul#search-results').fadeOut();
				}
			}
		});
	}
	return false;
}
$('.button-clear').on('click', function(e) {
	$('.search-no-results').fadeOut();
	$('ul#search-results').empty();
	$('ul#search-results').hide();
});

$(".search-input-group input[name=keyword]").on("keyup", function(e) {
	clearTimeout($.data(this, 'timer'));

	var keyword = $(this).val();
	
	if (keyword == '') {
		$("ul#search-results").fadeOut();
		$('.button-clear').fadeOut();
		$('.search-no-results').fadeOut();
	} else {
		$("ul#search-results").fadeIn();
		$("ul#search-results").addClass('mt-3')
		$(this).data('timer', setTimeout(search, 100));
	};

});

// Down arrow
$('div[data-scrolldown="true"]').on("click", function(e) {
	$("html, body").animate({
		scrollTop: $("#TopActivities").offset().top
	}, 500);
	
	e.stopPropagation();
});
$('div.booknow-div').on("click", function(e) {
	$("html, body").animate({
		scrollTop: $("#BookNow").offset().top
	}, 500);
	
	e.stopPropagation();
});

// Push to top
$('#totop').hide();
$(window).scroll(function() {
	"use strict";
	if ($(this).scrollTop() >= 100) {        // If page is scrolled more than 50px
		$('#totop').fadeIn(200);    // Fade in the arrow
		$('#totop').addClass('top-visible');
	} else {
		$('#totop').fadeOut(200);   // Else fade out the arrow
		$('#totop').removeClass('top-visible');
	}
});
$('#totop').click(function() {      // When arrow is clicked
	$('body,html').animate({
		scrollTop : 0                       // Scroll to top of body
	}, 500);
	return false;
});

$('button#tb_resa_directe').on('click', function(e) {
	e.stopPropagation();
	var pid = $(this).data('id');
	var cart = $(this).data('cart');
	var revendeurId = $(this).data('revendeur');
	
	tb_resa_directe(pid, revendeurId, cart);
});

function tb_resa_directe(id, revendeurId, cart, n){
	var url = "https://www.beenbiz.com/mp-paris75/prd.php?act=ajout-panier";
	url += "&id=" + id;
	url += "&booking="+revendeurId;
	url += "&j=1609372800";
	url += "&urlpanier="+cart;
	url += "&adulte=" + document.getElementById("p" + id).value;

	location.href= url;
}

Array.from(document.querySelectorAll('[data-bs-toggle="popover"]'))
	.forEach(popoverList => new Popover(popoverList))